module.exports = __webpack_public_path__ + "static/fipcspottyg4-ad79a9afc3e2889a90b0057e921180f5.jpeg";